module.exports = __webpack_public_path__ + "static/media/successIconKTM.8b99f4a9.svg";